import { render, staticRenderFns } from "./UserSmsList.vue?vue&type=template&id=d595dea8&"
import script from "./UserSmsList.vue?vue&type=script&lang=js&"
export * from "./UserSmsList.vue?vue&type=script&lang=js&"
import style0 from "./UserSmsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports